import { useEffect } from 'react';

import { auth } from '../firebase/firebase';
import useSocket from './socket-hook';

export interface ProactiveInsightMessage {
  sender: string; // 'JiraAgentV2' for the current (only) case
  text: string;
  isUser: boolean; // false
  hidden?: boolean; // false — still meant to be shown
  proactive?: boolean; // true
  createdAt: number;
}

export interface ProactiveInsightEvent {
  userId: string;
  sessionId: string;
  message: ProactiveInsightMessage;
}

// JiraAgentV2 can message a user without an inbound chatMessage first — currently a daily
// risk-check that only fires when something crosses the risk threshold. The message is already
// persisted into the user's studio-${userId} session by the time this fires; this event exists
// so the UI can surface it immediately (a toast) without polling. See rest-api.md "Proactive
// insights" / websocket.md `proactiveInsight`.
export function useProactiveInsights(onInsight: (event: ProactiveInsightEvent) => void) {
  const { on, off } = useSocket(auth.currentUser?.uid || '');

  useEffect(() => {
    const handler = (event: ProactiveInsightEvent) => onInsight(event);
    on('proactiveInsight', handler);
    return () => off('proactiveInsight', handler as (...args: unknown[]) => void);
  }, [on, off, onInsight]);
}
